import { ScreenName } from '@helpcenter/constants';
import type { RouteResource } from 'react-resource-router';
import { brandingResource } from 'routes/advanced-help-center/resources/multi-help-centers';
import { Login } from 'view/login';
import type { loginAnnouncementsCardQuery } from 'view/login/login-announcements/__generated__/loginAnnouncementsCardQuery.graphql';
import LoginAnnouncementsCardQuery from 'view/login/login-announcements/__generated__/loginAnnouncementsCardQuery.graphql';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { createRouteWithLayout, createRelayResource } from '@atlassian/help-center-common-util/resource-router';
import { anonymousScreenLayout, PORTAL_ROUTE_PREFIX, LOGIN_ROUTE } from '../common/constants';

const loginAnnouncementsCardResource = createRelayResource<loginAnnouncementsCardQuery>({
    type: 'HELP_CENTER_LOGIN_ANNOUNCEMENTS_CARD',
    getQuery: (_, { cloudId, helpCenterAri }: { cloudId: string; helpCenterAri: string }) => {
        return {
            parameters: LoginAnnouncementsCardQuery,
            variables: {
                cloudId,
                helpCenterAri,
            },
            options: {
                fetchPolicy: 'store-or-network',
            },
        };
    },
});

const resources: RouteResource[] = FeatureGates.checkGate('jsm_multi_helpcenter_login_ssr_improvements')
    ? [brandingResource, loginAnnouncementsCardResource]
    : [];

const portalLogin = {
    resources,
    name: 'portal-login',
    path: `${PORTAL_ROUTE_PREFIX}/user/login`,
    exact: true,
    component: Login,
};

const login = {
    resources,
    name: 'login',
    path: LOGIN_ROUTE,
    exact: true,
    component: Login,
};

const screenName = ScreenName.LOGIN;

const layoutProps = FeatureGates.checkGate('jsm_multi_helpcenter_login_ssr_improvements')
    ? { ...anonymousScreenLayout, prefetchBrandingModel: true }
    : anonymousScreenLayout;

export const loginRoute = createRouteWithLayout(login, screenName, layoutProps);
export const portalLoginRoute = createRouteWithLayout(portalLogin, screenName, layoutProps);
